import type { MessageType } from "@expert/shared-types";

import type { MessageTypeConfig, MessageTypeRegistry } from "./types";

// Source of truth for all message type behaviors and features.
export const messageTypeRegistry: MessageTypeRegistry = {
    Search: {
        alignsLeft: true,
        bubbleStyle: "reactive",
        supportsFeedback: true,
        supportsProactiveMode: false,
        supportsTag: false,
    },

    Proactive: {
        alignsLeft: true,
        bubbleStyle: "proactive",
        supportsFeedback: false,
        supportsProactiveMode: true,
        supportsTag: true,
    },

    Default: {
        alignsLeft: true,
        bubbleStyle: "proactive",
        supportsFeedback: false,
        supportsProactiveMode: false,
        supportsTag: true,
    },

    Error: {
        alignsLeft: true,
        bubbleStyle: "reactive",
        supportsFeedback: false,
        supportsProactiveMode: false,
        supportsTag: false,
    },

    Connection: {
        alignsLeft: true,
        bubbleStyle: "reactive",
        supportsFeedback: false,
        supportsProactiveMode: false,
        supportsTag: false,
    },

    SessionSummary: {
        alignsLeft: true,
        bubbleStyle: "aiGenerated",
        supportsFeedback: true,
        supportsProactiveMode: false,
        supportsTag: false,
    },

    GuideRecommendation: {
        alignsLeft: true,
        bubbleStyle: "aiGenerated",
        supportsFeedback: false,
        supportsProactiveMode: false,
        supportsTag: false,
    },

    Generic: {
        alignsLeft: false,
        bubbleStyle: "proactive",
        supportsFeedback: false,
        supportsProactiveMode: false,
        supportsTag: false,
    },

    Expert: {
        alignsLeft: false,
        bubbleStyle: "expert",
        supportsFeedback: false,
        supportsProactiveMode: false,
        supportsTag: false,
    },

    QuickAction: {
        alignsLeft: false,
        bubbleStyle: "expert",
        supportsFeedback: false,
        supportsProactiveMode: false,
        supportsTag: false,
    },

    SmartOffer: {
        alignsLeft: false,
        bubbleStyle: "smartOffer",
        supportsFeedback: false,
        supportsProactiveMode: false,
        supportsTag: false,
    },

    SmartOfferGeneric: {
        alignsLeft: false,
        bubbleStyle: "smartOfferGeneric",
        supportsFeedback: false,
        supportsProactiveMode: false,
        supportsTag: false,
    },

    SmartOfferResponse: {
        alignsLeft: false,
        bubbleStyle: "smartOfferResponse",
        supportsFeedback: false,
        supportsProactiveMode: false,
        supportsTag: false,
    },

    Separator: {
        alignsLeft: false,
        bubbleStyle: "reactive",
        supportsFeedback: false,
        supportsProactiveMode: false,
        supportsTag: false,
    },
};

export function getMessageTypeConfig(type: MessageType): MessageTypeConfig {
    return messageTypeRegistry[type];
}
